import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  MdTravelExplore,
  MdHome,
  MdArrowBack,
  MdForum,
  MdWorkspacePremium,
  MdInsights,
} from "react-icons/md";

export default function NotFound(): React.ReactElement {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-b from-surface/50 to-transparent p-6">
      <div className="mx-auto grid max-w-3xl place-items-center">
        <div className="card w-full p-8 text-center">
          {/* Icono + 404 */}
          <div className="mx-auto mb-4 grid place-items-center">
            <div className="icon-accent mb-2 rounded-2xl bg-primary/10 p-3 text-3xl text-primary">
              <MdTravelExplore />
            </div>
            <div className="font-mono text-5xl font-bold tracking-tight">
              404
            </div>
          </div>

          <h1 className="mb-2 text-2xl font-semibold">Página no encontrada</h1>
          <p className="mx-auto mb-6 max-w-xl text-sm opacity-80">
            No pudimos encontrar la ruta{" "}
            <code className="rounded bg-surface/70 px-1 py-0.5">
              {pathname || "/"}
            </code>
            . Puede que el enlace haya cambiado o no exista.
          </p>

          {/* Acciones principales */}
          <div className="mb-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <button
              className="btn btn-outline flex items-center gap-2"
              onClick={() => navigate(-1)}
            >
              <MdArrowBack /> Volver
            </button>
            <Link to="/" className="btn btn-primary flex items-center gap-2">
              <MdHome /> Ir al inicio
            </Link>
          </div>

          {/* Accesos rápidos */}
          <div className="mx-auto max-w-2xl">
            <div className="mb-3 text-left text-xs font-medium uppercase tracking-wide opacity-70">
              Accesos rápidos
            </div>
            <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
              <Link to="/community" className="btn btn-outline justify-start">
                <MdForum className="mr-2" />
                Comunidad
              </Link>
              <Link
                to="/certifications"
                className="btn btn-outline justify-start"
              >
                <MdWorkspacePremium className="mr-2" />
                Certificaciones
              </Link>
              <Link to="/stats" className="btn btn-outline justify-start">
                <MdInsights className="mr-2" />
                Estadísticas
              </Link>
              <Link
                to="/questionnaires"
                className="btn btn-outline justify-start"
              >
                {/* ícono genérico de insights reutilizado para mantener estilo */}
                <MdInsights className="mr-2" />
                Cuestionarios
              </Link>
            </div>
          </div>

          {/* Nota */}
          <p className="mt-8 text-xs opacity-60">
            Si crees que esto es un error, verifica la URL o vuelve al inicio.
          </p>
        </div>
      </div>
    </div>
  );
}
